export enum ActionType {
  logout = 'logout',
  accept = 'accept'
}
